(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};

    /**
     * The Campaign Template Communication inbox model for Yumbi Campaigns
     * @constructor
     */
    class InboxMessage {
        constructor() {
            this.Blurb = "";
            this.Template = "";
            this.ExpiresInDays = 45;
        }

        /**
         * Initialises the campaign with the campaign returned from the API
         */
        initialiseInboxMessage(inboxMessage) {
            return _.extend(this, inboxMessage);
        };
    }

    window.Dashboard.Models.InboxMessage = InboxMessage;
})();
